<template>
  <div class="home">
    <keep-alive>
      <Menu ref="mychild"></Menu>
    </keep-alive>
    
    <!-- 产品体系 -->
    <!-- <div class="section pdtio">
      <div class="sectionTitle">
        <div class="titleMain">
          <span class="titleTxt cptx"></span>
        </div>
      </div>


      <div class="home-logo">
        <div class="system-nav">
          <button class="nav-arrow" @click="handlePrev">
            <img src="../../styles/images/jt1.png" alt="">
          </button>
          <div class="nav-list" ref="navList">
            <div class="nav-item" v-for="item in navItems" :key="item.name">
              <div class="nav-icon" :class="item.active ? 'active' : ''">
            
                <img v-if="item.iconClass == 'st'" src="../../styles/images/txImg/Frame-10.png" alt="">
              
                <img v-if="item.iconClass == 'sc'" src="../../styles/images/txImg/Frame-12.png" alt="">
           
                <img v-if="item.iconClass == 'xfm'" src="../../styles/images/txImg/Frame-14.png" alt="">
          
                <img v-if="item.iconClass == 'cw'" src="../../styles/images/txImg/Frame-16.png" alt="">
            
                <img v-if="item.iconClass == 'xf'" src="../../styles/images/txImg/Frame.png" alt="">
               
                <img v-if="item.iconClass == 'bx'" src="../../styles/images/txImg/Frame-2.png" alt="">
           
                <img v-if="item.iconClass == 'jf'" src="../../styles/images/txImg/Frame-8.png" alt="">
               
                <img v-if="item.iconClass == 'nn'" src="../../styles/images/txImg/Frame-6.png" alt="">
             
                <img v-if="item.iconClass == 'yj'" src="../../styles/images/txImg/Frame-4.png" alt="">
              </div>
              <div class="nav-label">{{ item.name }}</div>
            </div>
          </div>
          <button class="nav-arrow" @click="handleNext">
            <img src="../../styles/images/jt2.png" alt="">
          </button>
        </div>
        
        

      </div>
    </div> -->

    <!-- <div class="section">
      <div class="sectionTitle">
        <div class="titleMain">
          <i class="titlePoint"></i>
          <span class="titleTxt newTxt newBgOne"></span>
          <i class="titlePoint"></i>
        </div>
        <div class="titleSub">PRODUCT SYSTEM</div>
      </div>

      <div class="sectionOneSlide">
        <el-carousel
          :autoplay="true"
          arrow="always"
          indicator-position="none"
          :interval="5000"
        >
          <el-carousel-item
            class="carouselWrap"
            v-for="(item1, index) in productList"
            :key="index"
          >
            <div
              class="carouselList"
              @mouseover="changeCarousel(item.id)"
              @mouseout="changeCarousel()"
              :class="showId == item.id ? 'carouselListActive' : ''"
              v-for="item in item1"
              :key="item.id"
              @click="jumpToList('product', item.type)"
            >
              <div class="carouselImg">
                <img
                  v-if="showId == item.id"
                  src="../../styles/images/slideBgActive.png"
                  alt=""
                />
                <img v-else src="../../styles/images/slidBg.png" alt="" />
                <div class="center">
                  <img v-if="showId == item.id" :src="item.iconCUrl" alt="" />
                  <img v-else :src="item.iconUcUrl" alt="" />
                </div>
              </div>
              <div class="carouselTxt">
                <span class="carouselTxtMain">{{ item.title }}</span>
                <span class="carouselTxtSub">{{ item.typeLable }}</span>
              </div>
              <p class="carouselDesc">
                {{item.showInfo}}
              </p>
              <div class="carouselBtn">详情</div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div> -->

    <div class="section1 aboutUs mt-60">
      <div class="sectionTitle">
        <div class="titleMain">
          <span class="titleTxt"></span>
        </div>
      </div>
      <div class="aboutDesc">
        <div class="us-l">
          <div class="us-one" @click="jumpToList('aboutUs', 3)"></div>
          <div class="us-two" @click="jumpToList('aboutUs', 1)"></div>
          <div class="us-three" @click="jumpToList('aboutUs', 2)"></div>
        </div>
        <div class="us-r" >
          <div class="usr-t" ref="aboutDesc"></div>
          <div class="usr-b">
            <span @click="jumpToList('aboutUs', 1)"></span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 客户案例 -->
    <div class="section industryWrap newindustryWrap">
      <div class="sectionTitle">
        <div class="titleMain">
          <span class="titleTxt newHy"></span>
        </div>
      </div>
      <!-- <div class="industrySlide">
        <div class="hy-l">
          <div
            class="hy-l1"
            @click="jumpToList('industry', zhsw.businessId)"
          ></div>
          <div
            class="hy-l2"
            @click="jumpToList('industry', zhgw.businessId)"
          ></div>
        </div>
        <div class="hy-r">
          <div
            class="hy-r1"
            @click="jumpToList('industry', zhcs.businessId)"
          ></div>
          <div class="hy-r2">
            <div
              class="hy-r2-l"
              @click="jumpToList('industry', zhxf.businessId)"
            ></div>
            <div
              class="hy-r2-r"
              @click="jumpToList('industry', zhjt.businessId)"
            ></div>
          </div>
        </div>
      </div> -->
      <div class="industrySlide">
        <!-- <div class="industrySlideLeft">
          <div class="industrySlideLeftList" style="width:585px;height:300px;" @click="jumpToList('product', zhcs.type)">
            <img src="../../styles/images/industry/1.png" alt="">
          </div>
          <div class="industrySlideLeftList" style="width:272px;height:300px;" @click="jumpToList('product', sjcj.type)">
            <img src="../../styles/images/industry/2.png" alt="">
          </div>
          <div class="industrySlideLeftList" style="width:330px;height:216px;" @click="jumpToList('product', zhly.type)">
            <img src="../../styles/images/industry/4.png" alt="">
          </div>
          <div class="industrySlideLeftList" style="width:527px;height:216px;" @click="jumpToList('product', zhsw.type)">
            <img src="../../styles/images/industry/5.png" alt="">
          </div>
        </div>
        <div class="industrySlideRight">
          <div class="industrySlideRightList" style="width:320px;height:220px;" @click="jumpToList('product', zhdw.type)">
            <img src="../../styles/images/industry/3.png" alt="">
          </div>
          <div class="industrySlideRightList" style="width:320px;height:296px;" @click="jumpToList('product', dxsj.type)">
            <img src="../../styles/images/industry/6.png" alt="">
          </div>
        </div> -->

        <div class="flexTx mb-12">
          <div class="flexTxCot pr-12" style="width:588px;height:216px;" @click="jumpToList('product', zhcs.type)">
            <img class="flexImg" src="../../styles/images/homeTx/szst.png" alt="数字食堂">
          </div>
           <div class="flexTxCot pr-12" style="width:588px;height:216px;" @click="jumpToList('product', scgl.type)">
            <img  class="flexImg" src="../../styles/images/homeTx/5.png" alt="食材">
          </div>

           
         
         
          
        </div>

         <div class="flexTx mb-12">
          <div class="flexTxCot pr-12" style="width:388px;height:216px;" @click="jumpToList('product', sjcj.type)">
            <img  class="flexImg" src="../../styles/images/homeTx/4.png" alt="财务">
          </div>
            <div class="flexTxCot pr-12" style="width:388px;height:220px;" @click="jumpToList('product', gyl.type)">
            <img class="flexImg" src="../../styles/images/homeTx/gylimg.png" alt="供应链">
          </div>
          <div class="flexTxCot " style="width:388px;height:220px;" @click="jumpToList('product', yjzc.type)">
            <img class="flexImg" src="../../styles/images/homeTx/yjzc.png" alt="硬件支撑">
          </div>

        
        
        </div>

        <div class="flexTx ">
          <div class="flexTxCot pr-12" style="width:288px;height:220px;" @click="jumpToList('product', zhdw.type)">
            <img  class="flexImg" src="../../styles/images/homeTx/3.png" alt="教辅">
          </div>
            <div class="flexTxCot pr-12"  style="width:288px;height:220px;" @click="jumpToList('product', zhly.type)">
            <img  class="flexImg" src="../../styles/images/homeTx/6.png" alt="校服">
          </div>
          <div class="flexTxCot pr-12" style="width:288px;height:220px;" @click="jumpToList('product', zhsw.type)">
            <img  class="flexImg" src="../../styles/images/homeTx/7.png" alt="保险">
          </div>
          <div class="flexTxCot " style="width:288px;height:220px;" @click="jumpToList('product', dxsj.type)">
            <img class="flexImg" src="../../styles/images/homeTx/8.png" alt="牛奶">
          </div>
          
         
         
        </div>

       

        
      
        <!-- <div class="flexTx mb-12">
          <div class="flexTxCot pr-12" style="width:340px;height:216px;" @click="jumpToList('product', zhcs.type)">
            <img class="flexImg" src="../../styles/images/homeTx/szst.png" alt="数字食堂">
          </div>
          <div class="flexTxCot pr-12" style="width:340px;height:216px;" @click="jumpToList('product', gyl.type)">
            <img class="flexImg" src="../../styles/images/homeTx/gylimg.png" alt="供应链">
          </div>
          <div class="flexTxCot " style="width:340px;height:216px;" @click="jumpToList('product', yjzc.type)">
            <img class="flexImg" src="../../styles/images/homeTx/yjzc.png" alt="硬件支撑">
          </div>
          
        </div>

        <div class="flexTx mb-12">
          <div class="flexTxCot pr-12" style="width:562px;height:220px;" @click="jumpToList('product', zhdw.type)">
            <img src="../../styles/images/homeTx/3.png" alt="教辅">
          </div>
          <div class="flexTxCot pr-12" style="width:295px;height:220px;" @click="jumpToList('product', sjcj.type)">
            <img src="../../styles/images/homeTx/4.png" alt="财务">
          </div>
          <div class="flexTxCot " style="width:320px;height:220px;" @click="jumpToList('product', scgl.type)">
            <img src="../../styles/images/homeTx/5.png" alt="食材">
          </div>
        </div>

        <div class="flexTx">
          <div class="flexTxCot pr-12" style="width:330px;height:220px;" @click="jumpToList('product', zhly.type)">
            <img src="../../styles/images/homeTx/6.png" alt="校服">
          </div>
          <div class="flexTxCot pr-12" style="width:526px;height:220px;" @click="jumpToList('product', zhsw.type)">
            <img src="../../styles/images/homeTx/7.png" alt="保险">
          </div>
          <div class="flexTxCot " style="width:320px;height:220px;" @click="jumpToList('product', dxsj.type)">
            <img src="../../styles/images/homeTx/8.png" alt="牛奶">
          </div>
        </div> -->
      
      </div>
    </div>

    <!-- 合作伙伴 -->
    
    <!-- 新闻中心 -->
    <div class="section newslist">
      <div class="sectionTitle">
        <div class="titleMain">
          <span class="titleTxt"></span>
        </div>
      </div>
      <div class="newsBody">
     
        <div class="new-l">
          <div class="new-l-t">
           <div class="new-t-l">
              <span>企业新闻 </span>
            <span class="newType"></span>
           </div>
           <div class="new-t-r" @click="jumpToList('newsCenter', 1)">
             
           </div>
          </div>
          <div class="new-l-c"></div>
          <div class="new-l-b">
            <div class="newa" v-for="item in newData" :key="item.id">
              <div class="newa-l">
                <img :src="item.url" alt="" />
              </div>
              <div class="newa-r">
                <div class="newa-ra">
                  <i class="black-y"></i>
                </div>
                <div class="newa-rb">
                  <div
                    class="newa-title"
                    @click="jumpToList('newsCenter', 1, item)"
                  >
                    {{ item.title }}
                  </div>
                  <div class="newa-info">{{ item.showInfo }}</div>
                </div>
                <div class="newa-rc">{{ item.showTime }}</div>
              </div>
            </div>
          </div>
        </div>
     
        <div class="new-r">
          <div class="new-l-t">
            <div class="new-t-l">
               <span>行业动态 </span>
            <span class="newType"></span>
            </div>
            <div class="new-t-r" @click="jumpToList('newsCenter', 2)">
              
            </div>
          </div>
          <div class="new-l-c"></div>
          <div class="new-l-b">
            <div class="newa" v-for="item in newData2" :key="item.id">
              <div class="newa-r newa-r2">
                <div class="newa-ra">
                  <i class="black-y"></i>
                </div>
                <div class="newa-rb">
                  <div
                    class="newa-title"
                    @click="jumpToList('newsCenter', 2, item)"
                  >
                    {{ item.title }}
                  </div>
                  <div class="newa-info">{{ item.showInfo }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <!-- <div class="section aboutUs">
      <div class="sectionTitle">
        <div class="titleMain">
          <span class="titleTxt"></span>
        </div>
      </div>
      <div class="aboutDesc">
        <div class="us-l">
          <div class="us-one" @click="jumpToList('aboutUs', 3)"></div>
          <div class="us-two" @click="jumpToList('aboutUs', 1)"></div>
          <div class="us-three" @click="jumpToList('aboutUs', 2)"></div>
        </div>
        <div class="us-r" >
          <div class="usr-t" ref="aboutDesc"></div>
          <div class="usr-b">
            <span @click="jumpToList('aboutUs', 1)"></span>
          </div>
        </div>
      </div>
    </div> -->


    <div class="section pdtio">
      <div class="sectionTitle">
        <div class="titleMain">
          <span class="titleTxt hehb"></span>
        </div>
      </div>


      <div class="home-logo">
        <div class="logo-grid">
          <div class="logo-item" v-for="(item, index) in logosImgs" :key="index">
            <img :src="item.src" :alt="item.name" class="logo-img" />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script >
import config from "@/config/url.config";
import {
  listProductType,
  getBusinessList,
  getIndustry,
  getSysNews,
  getCompanyIntro,
  productList
} from "@/api/manage";

import Menu from "../../components/menu/menu.vue";
import homeFooter1 from "../../styles/images/homeFooterCont/1.png";
import homeFooter2 from "../../styles/images/homeFooterCont/2.png";
import homeFooter3 from "../../styles/images/homeFooterCont/3.png";
import homeFooter4 from "../../styles/images/homeFooterCont/4.png";
import homeFooter5 from "../../styles/images/homeFooterCont/5.png";
import homeFooter6 from "../../styles/images/homeFooterCont/6.png";
import homeFooter7 from "../../styles/images/homeFooterCont/7.png";
import homeFooter8 from "../../styles/images/homeFooterCont/8.png";
import homeFooter9 from "../../styles/images/homeFooterCont/9.png";
import homeFooter10 from "../../styles/images/homeFooterCont/10.png";
import homeFooter11 from "../../styles/images/homeFooterCont/11.png";
import homeFooter12 from "../../styles/images/homeFooterCont/12.png";
import homeFooter13 from "../../styles/images/homeFooterCont/13.png";
import homeFooter14 from "../../styles/images/homeFooterCont/14.png";
import homeFooter15 from "../../styles/images/homeFooterCont/15.png";
import homeFooter16 from "../../styles/images/homeFooterCont/16.png";
import homeFooter17 from "../../styles/images/homeFooterCont/17.png";
import homeFooter18 from "../../styles/images/homeFooterCont/18.png";
import homeFooter19 from "../../styles/images/homeFooterCont/19.png";
import homeFooter20 from "../../styles/images/homeFooterCont/20.png";
import homeFooter21 from "../../styles/images/homeFooterCont/21.png";
import homeFooter22 from "../../styles/images/homeFooterCont/22.png";
import homeFooter23 from "../../styles/images/homeFooterCont/23.png";
import homeFooter24 from "../../styles/images/homeFooterCont/24.png";
import homeFooter25 from "../../styles/images/homeFooterCont/25.png";
import homeFooter26 from "../../styles/images/homeFooterCont/26.png";
import homeFooter27 from "../../styles/images/homeFooterCont/27.png";
import homeFooter28 from "../../styles/images/homeFooterCont/28.png";
import homeFooter29 from "../../styles/images/homeFooterCont/29.png";
import homeFooter30 from "../../styles/images/homeFooterCont/30.png";
export default {
  data() {
    return {
      navScrollPosition: 0, // 添加滚动位置状态
      navItemWidth: 1000, // 每个导航项的宽度(包括gap)
      navItems: [
        { name: '"数字食堂"监管平台', iconClass: "st", active: false },
        { name: "食材管理系统", iconClass: "sc", active: false },
        { name: "消费管理系统", iconClass: "xfm", active: false },
        { name: "财务管理系统", iconClass: "cw", active: true },
        { name: "校服管理系统", iconClass: "xf", active: true },
        { name: "保险管理系统", iconClass: "bx", active: true },
        { name: "教辅管理系统", iconClass: "jf", active: true },
        { name: "牛奶管理系统", iconClass: "nn", active: true },
        { name: "硬件支撑", iconClass: "yj", active: true },
      ],
      logosImgs: [
        {name: '宜昌市教育局', src: homeFooter1 },
        {name: '恩施市教育局',src: homeFooter2 },
        {name: '仙桃市教育局',src: homeFooter3},
        {name: '咸宁市教育局',src: homeFooter4},
        {name: '老河口市教育局',src: homeFooter5},
        {name: '广水市教育局', src: homeFooter6 },
        {name: '十堰市教育局', src: homeFooter7 },
        {name: '黄石市教育局', src: homeFooter8 },
        {name: '黄冈市教育局', src: homeFooter9 },
        {name: '潜江市教育局', src: homeFooter10 },
        {name: '荆州市教育局', src: homeFooter11 },
        {name: '郑州市教育局', src: homeFooter12 },
        {name: '长治市教育局', src: homeFooter13 },
        {name: '滁州市教育局', src: homeFooter14 },
        {name: '本溪市教育局', src: homeFooter15 },
        {name: '中国银行',src: homeFooter16},
        {name: '招商银行',src: homeFooter17},
        {name: '建设银行',src: homeFooter18},
        {name: '中信银行',src: homeFooter19},
        {name: '中国农业银行',src: homeFooter20},
        {name: '交通银行',src: homeFooter21},
        {name: '湖北省农村信用社',src: homeFooter22},
        {name: '湖北银行',src: homeFooter23},
        {name: '中国工商银行',src: homeFooter24},
        {name: '中国邮政储蓄银行',src: homeFooter25},
        {name: 'HIKVISION',src: homeFooter26},
        {name: '诺诺网',src: homeFooter27},
        {name: '科大讯飞',src: homeFooter28},
        {name: '阿里云',src: homeFooter29},
        {name: '三峡云',src: homeFooter30},
        
        // {name: 'Aisino航天信息',src: homeFooter7},
        // {name: '三峡农商银行',src: homeFooter12},
        // {name: '中国工商银行',src: homeFooter13},
        // {name: '中国银行',src: homeFooter14},
        // {name: '建设银行',src: homeFooter15},
        // {name: '武汉农村商业银行',src: homeFooter16},
        // {name: '十堰高级职业学习',src: homeFooter17},
        // {name: '三峡旅游职业技术学院',src: homeFooter18},
        // {name: '仙桃市第一中学',src: homeFooter19},
        // {name: '十堰外国语学校',src: homeFooter20},
      ],
      src: "",
      newsIndex: "1",
      carouselActive: false,
      list: 3,
      productList: [],
      showId: "",
      businessList: [], //行业应用列表
      industryList: [], //获取到行业应用
      newData: [], //企业新闻
      newData2: [], //行业动态
      aboutUs: "",
      zhcs: "",
      dxsj: "",
      zhdw: "",
      zhsw: "",
      sjcj: "",
      zhly: "",
      yjzc: "",
      scgl: "",
      gyl: "",

    };
  },
  components: {
    Menu,
  },
  async created() {
    const request = (promise, name) => promise.catch((error) => {
      console.error(`[Home] ${name} request failed`, error);
      return { data: null };
    });
    const [res, res2, res3, res4, res5, res6] = await Promise.all([
      request(productList({ pageNo: 1, pageSize: 999 }), "productList"),
      request(getBusinessList({ pageNo: 1, pageSize: 999 }), "businessList"),
      request(getIndustry({ pageNo: 1, pageSize: 999, sortType: "a" }), "industry"),
      request(getCompanyIntro({ type: 1 }), "companyIntro"),
      request(getSysNews({
        type: 1,
        pageNo: 1,
        pageSize: 3,
        sortType: "a",
      }), "companyNews"),
      request(getSysNews({
        type: 2,
        pageNo: 1,
        pageSize: 3,
        sortType: "a",
      }), "industryNews"),
    ]);

    console.log('获取产品体系列表--------------',res);
    if (res.data) {
      this.productList = [];
      let flag = 1;
      let arr = [];
      let obj = {};
      let newData=[]//存放没有图片及标题的产品体系
      res.data.map(item=>{
        if(item.title!=''&&item.sysPictureIs){
          newData.push(item)
        }
      })

      res.data=newData
       console.log('res.data',res.data);
      res.data.forEach((item, index) => {
        //将数据分为4个4个一组
        if (item.sysPictureIs) {
          item.iconCUrl =
            config.baseURL + item.sysPictureIs.fileUrl + item.sysPictureIs.newName;
          item.iconUcUrl =
            config.baseURL + item.sysPictureNs.fileUrl + item.sysPictureNs.newName;
        }
        if (index == res.data.length - 1) {
          arr.push(item);
          obj[flag] = JSON.parse(JSON.stringify(arr));
        } else if (arr.length < 3) {
          arr.push(item);
        } else if (arr.length == 3) {
          arr.push(item);
          obj[flag] = JSON.parse(JSON.stringify(arr));
          arr = [];
          flag = flag + 1;
        }
      });
      if (res.data.length <= 3) {
        obj[1] = res.data;
      }
      //let flage=0//获取对象的长度，若小于2，则将对象内容复制并添加，使其长度大于2，
      for (let k in obj) {
        this.productList.push(obj[k]);
      }
      if (this.productList.length == 2) {
        this.productList = this.productList.concat(this.productList);
      } else if (this.productList.length == 1) {
        let arr = JSON.parse(JSON.stringify(this.productList));
        this.productList = this.productList.concat(arr, arr);
      }
    } else {
      this.productList = [];
    }
    console.log('获取行业应用列表',res2);
    if (res2.data) {
      res2.data.forEach((item) => {
        if (item.sysPicture) {
          item.url =
            config.baseURL +
            item.sysPicture["fileUrl"] +
            item.sysPicture["newName"];
        }
      });
      this.businessList = res2.data;
    } else {
      this.businessList = [];
    }
    console.log('获取到首页--行业应用',res3);
    if (res3.data) {
      this.industryList = res3.data;
      this.industryList.forEach((item) => {
        this.businessList.map((item2) => {
          if (item.businessId == item2.id) {
            item.busName = item2.busName;
            item.url = item2.url;
            if (item2.busName == "智慧城市") {
              this.zhcs = item; // 数字食堂
            } else if (item2.busName == "地下数据") {
              this.dxsj = item; // 牛奶
            } else if (item2.busName == "智慧电网") {
              this.zhdw = item; // 数字后勤
            } else if (item2.busName == "综合水务") {
              this.zhsw = item; // 保险
            } else if (item2.busName == "数据采集") {
              this.sjcj = item; // 财务
            } else if (item2.busName == "智慧林业") {
              this.zhly = item; // 校服
            }
          }
        });
      });
    } else {
      this.industryList = [];
    }
    if (res4.data) {
      const text = decodeURI(res4.data.text || "");
      this.aboutUs = text;
      const renderAboutDescription = () => {
        if (this.$refs["aboutDesc"]) {
          this.$refs["aboutDesc"].innerHTML = text;
        }
      };
      renderAboutDescription();
      this.$nextTick(renderAboutDescription);
    }

    if (res5.data) {
      this.newData = res5.data;
      this.newData.forEach((item) => {
        let aa = decodeURI(item.content);
        let date  = new Date(item.createTime)
        let y = date.getFullYear()
        let m = date.getMonth()+1
        let d = date.getDate()
        var afstr = aa.replace(/<[^>]+>/g, ""); //用正则去除内容中的标签
        afstr = afstr.replace(
          /(\s|&mdash;|&nbsp;|&ldquo;|&rdquo;|&hellip;)/g,
          ""
        ); //拿到展示的文本，
        item.showInfo = afstr; //拿到去除html标签之后的展示文本
        item.url =
          config.baseURL + item.sysPicture.fileUrl + item.sysPicture.newName;
          item.showTime = y+'-'+m+'-'+d
      });
      
      console.log('this.newData',this.newData);
    } else {
      this.newData = [];
    }
    if (res6.data) {
      this.newData2 = res6.data;
      this.newData2.forEach((item) => {
        let aa = decodeURI(item.content);
        var afstr = aa.replace(/<[^>]+>/g, ""); //用正则去除内容中的标签
        afstr = afstr.replace(
          /(\s|&mdash;|&nbsp;|&ldquo;|&rdquo;|&hellip;)/g,
          ""
        ); //拿到展示的文本，
        item.showInfo = afstr; //拿到去除html标签之后的展示文本
      });
    } else {
      this.newData2 = [];
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    if (this.aboutUs && this.$refs["aboutDesc"]) {
      this.$refs["aboutDesc"].innerHTML = this.aboutUs;
    }
  },
  methods: {
    handlePrev() {
      const navList = this.$refs.navList;
      const scrollAmount = 300; // 每次滚动的距离
      
      this.navScrollPosition = Math.max(
        this.navScrollPosition - scrollAmount, 
        0
      );
      
      navList.scrollTo({
        left: this.navScrollPosition,
        behavior: 'smooth'
      });
    },
    handleNext() {
      const navList = this.$refs.navList;
      const scrollAmount = 300; // 每次滚动的距离
      const maxScroll = navList.scrollWidth - navList.clientWidth;
      
      this.navScrollPosition = Math.min(
        this.navScrollPosition + scrollAmount,
        maxScroll
      );
      
      navList.scrollTo({
        left: this.navScrollPosition,
        behavior: 'smooth'
      });
    },
    changeCarousel(id) {
      this.showId = id || "";
    },
    async jumpToList(name, index, data) {
      if (name == "product") {
        sessionStorage.setItem("index", 2);
      } else if (name == "industry") {
        // industry
        sessionStorage.setItem("index", 4);
      } else if (name == "newsCenter") {
        sessionStorage.setItem("index", 3);
        return this.$router.push({
          name: name,
          params: { id: index, data: data },
        });
      }else if(name=='aboutUs'){
        sessionStorage.setItem("index", 5);
      }
      this.$router.push({ name: name, params: { id: index } });
    },
  },
};
</script>

<style lang="less" scoped>
.home{
  position: relative;
}
.section {
  padding: 62px 0;
}
.section1 {
  padding: 62px 0;
}
.mt-60 {
  margin-top: 60px;
}
.newindustryWrap {
  padding: 48px 0 0 !important;
}
.new-t-r{
  cursor: pointer;
  width: 51px;
  height: 14px;
  margin-top: 7px;
  background: url('../../styles/images/btn_MORE.png') no-repeat;
}
.titleMain {
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: center;
}
.titlePoint {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #428fef;
}
.industryWrap .titlePoint,
.aboutUs .titlePoint {
  background-color: #fff;
}
.titleTxt {
  display: inline-block;
  font-size: 42px;
  line-height: 42px;
  color: #428fef;
  margin: 0 40px;
}
.newTxt {
  width: 381px;
  height: 64px;
}
.newBgOne {
  background: url("../../styles/images/Product System_title.png");
}
.newHy {
  width: 437px;
  height: 87px;
  // background: url("../../styles/images/newImages/khal.png");
  background: url("../../styles/images/newImages/cptx.png");
  
  background-size: 100% 100%;
   background-position: center;
  background-repeat: no-repeat;
}
.hehb {
  width: 437px;
  height: 87px;
  background: url("../../styles/images/newImages/hzhb.png");
  background-size: 100% 100%;
   background-position: center;
  background-repeat: no-repeat;
}
.cptx {
  width: 437px;
  height: 87px;
  background: url("../../styles/images/newImages/cptx.png");
  background-size: 100% 100%;
   background-position: center;
  background-repeat: no-repeat;
}
.industryWrap .titleTxt,
.aboutUs .titleTxt {
  color: #fff;
}
.titleSub {
  text-align: center;
  font-size: 18px;
  line-height: 18px;
  margin-top: 20px;
  font-family: "Adobe Heiti Std";
  color: #999999;
}
.industryWrap .titleSub,
.aboutUs .titleSub {
  color: #b8b8b8;
}
.carouselList {
  width: 253px;
  margin:0 31px;
  cursor: pointer;
}
.carouselImg {
  margin: 0 auto;
  width: 124px;
  height: 124px;
  line-height: 124px;
  text-align: center;
  position: relative;
}
.center {
  /* width: 80px;
  height: 80px; */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  line-height: 80px;
}
.carouselListActive .carouselBtn {
  background: url(../../styles/images/detailActive.png) no-repeat left top;
  background-size: 100% 100%;
}
.carouselImg img {
  vertical-align: middle;
  width: 100%;
  height: 100%;
}
.carouselTxt {
  margin-bottom: 15px;
}
.carouselTxt span {
  text-align: center;
  display: block;
}
.carouselTxtMain {
  font-size: 24px;
  line-height: 24px;
  color: #333;
}
.carouselTxtSub {
  font-size: 16px;
  line-height: 16px;
  color: #999;
  margin-top: 10px;
}
.carouselDesc {
  font-size: 18px;
  color: #000d19;
  line-height: 26px;
  margin-bottom: 25px;
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.carouselBtn {
  float: right;
  text-align: center;
  width: 80px;
  height: 40px;
  line-height: 35px;
  background: url(../../styles/images/detail.png) no-repeat left top;
  background-size: 100% 100%;
  font-size: 16px;
  color: #fff;
}
.carouselWrap {
  display: flex;
}
.industryWrap {
  height: 900px;
}
.newsBody {
  width: 1200px;
  height: 349px;
  margin: 62px auto 84px;
  display: flex;
  justify-content: space-between;
}
.new-l-t {
  font-weight: 700;
  display: flex;
    justify-content: space-between;
}
.newType {
  width: 51px;
  margin-left: 5px;
  height: 11px;
  display: inline-block;
  background: url("../../styles/images/newImages/nes_title_one.png") no-repeat;
}
.new-r .newType {
  width: 77px;
  background: url("../../styles/images/newImages/nes_title_two.png") no-repeat;
}
.new-l-c {
  width: 100%;
  height: 3px;
  background-color: #4490ef;
  margin-top: 5px;
}
.newa {
  height: 90px;
  background-color: #f7f7f7;
  margin-top: 10px;
  display: flex;
}
.newa-l {
  position: relative;
  width: 90px;
  height: 90px;
  overflow: hidden;
}
.newa-l img {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  height: 90px;
  transform: translate(-50%, -50%);
}
.new-l-b {
  width: 100%;
  height: 300px;
  margin-top: 20px;
  overflow: hidden;
}
.new-l {
  width: 777px;
  height: 100%;
}
.new-r {
  width: 371px;
  height: 100%;
}
.new-l-b .newa .newa-r2 {
  width: 350px;
  margin: 22px 0;
}
.new-l-b .newa .newa-r2 .newa-title {
  width: 310px;
}
.new-l-b .newa .newa-r2 .newa-info {
  width: 260px;
}
.newa-title:hover {
  cursor: pointer;
}
.new-l-b .newa .newa-r2 .newa-ra {
  width: 24px;
  padding-left: 4px;
}
.industrySlide {
  width: 1200px;
  // height: 531px;
  margin: 60px auto 0;
  // display: flex;
}
.newa-r {
  width: 687px;
}
.newa-r {
  display: flex;
  margin: 22px 14px;
}
.newa-ra {
  width: 15px;
  height: 100%;
}
.newa-rb {
  width: 560px;
}
.newa-info {
  font-size: 13px;
  margin-top: 9px;
  color: #666;
  width: 333px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*禁止换行*/
  text-overflow: ellipsis; /*省略号*/
}
.newa-rc {
  font-size: 13px;
  color: #666;
  text-align: center;
  width: 88px;
  line-height: 46px;
}
.newa-title {
  font-size: 15px;
  font-weight: 700;
  font-family: -webkit-pictograph;
  width: 439px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*禁止换行*/
  text-overflow: ellipsis; /*省略号*/
}
.black-y {
  display: block;
  width: 4px;
  height: 4px;
  margin-top: 9px;
  border-radius: 50%;
  background-color: #000;
}
.hy-l {
  width: 520px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
.hy-l1 {
  height: 229px;
  background: url("../../styles/images/newImages/hangye_pic_one.png") no-repeat;
}
.hy-l2 {
  height: 289px;
  background: url("../../styles/images/newImages/hangye_pic_two.png") no-repeat;
}
.hy-r {
  width: 667px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.hy-r1 {
  height: 333px;
  background: url("../../styles/images/newImages/hangye_pic_three.png")
    no-repeat;
}
.hy-r2 {
  height: 185px;
  display: flex;
  justify-content: space-between;
}
.hy-r2-l {
  width: 315px;
  background: url("../../styles/images/newImages/hangye_pic_four.png") no-repeat;
}
.hy-r2-r {
  width: 338px;
  background: url("../../styles/images/newImages/hangye_pic_five.png") no-repeat;
}
.hy-l1:hover,
.hy-l2:hover,
.hy-r1:hover,
.hy-r2-l:hover,
.hy-r2-r:hover {
  cursor: pointer;
}
.industryImg {
  position: relative;
  width: 152px;
  height: 152px;
  margin: 0 auto;
  background: url("../../styles/images/hangye_icon_box@2x.png") no-repeat center;
  background-size: 100% 100%;
}
.industryImg .center {
  width: 57px;
  height: 69px;
}
.industryImg .center img {
  width: 100%;
  height: 100%;
}
.industryTxt span {
  display: block;
  text-align: center;
}
.industryTxtMain {
  margin-top: 15px;
  font-size: 30px;
  line-height: 30px;
  color: #fefefe;
}
.industryTxtSub {
  margin-top: 15px;
  font-size: 20px;
  line-height: 20px;
  color: #fefefe;
  font-family: "Source Han Sans CN";
}
.industryDesc {
  width: 1150px;
  font-size: 18px;
  line-height: 36px;
  color: #fff;
  margin: 20px auto 0;
}
.aboutUs {
  height: 600px;
  padding: 0 !important;
}
.aboutUs .titleTxt {
  width: 437px;
  height: 87px;
  background: url("../../styles/images/newImages/gywm.png") no-repeat;
}
.aboutDesc {
  width: 1157px;
  height: 398px;
  margin: 73px auto;
  display: flex;
  justify-content: space-between;
}
.us-l {
  width: 533px;
  position: relative;
  height: 395px;
  margin-top: 3px;
  background: url("../../styles/images/newImages/about_pic.png") no-repeat;
}
.us-l div {
  position: absolute;
}
.us-l div:hover {
  cursor: pointer;
}
.us-one {
  top: 57px;
  left: 0px;
  width: 169px;
  height: 230px;
}
.us-two {
  top: 0px;
  left: 183px;
  width: 169px;
  height: 344px;
}
.us-three {
  top: 56px;
  left: 363px;
  width: 169px;
  height: 231px;
}
.us-r {
  width: 592px;
  height: 395px;
  overflow: hidden;
}
.newsWrap {
  display: flex;
  margin-top: 60px;
}
.newsImg {
  position: relative;
  width: 750px;
  height: 400px;
  margin-left: 200px;
  margin-right: 60px;
}
.newsImgTxt {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 70px;
  width: 100%;
  background-color: #428fef;
  line-height: 70px;
  color: #fff;
  font-size: 20px;
  text-align: center;
}
.newsTabs {
  width: 778px;
  display: flex;
  justify-content: space-between;
  height: 74px;
  line-height: 74px;
  background-color: #e9e9e9;
  margin-bottom: 40px;
  cursor: pointer;
}
.newsTabs ul {
  display: flex;
}
.newsTabs li {
  text-align: center;
  width: 174px;
  font-size: 20px;
}
li.newsTabsActive {
  color: #fff;
  background-color: #428fef;
}
.moreNews {
  font-size: 18px;
  color: #2f445b;
  margin-right: 30px;
}
.newsIcon {
  width: 56px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  font-size: 30px;
  margin-right: 15px;
  background-color: #dcdcdc;
  color: #fff;
}
.newsIconActive {
  background-color: #428fef;
}
.newsTabList {
  display: flex;
  margin-top: 53px;
  cursor: pointer;
}
.newsTabTxt {
  width: 440px;
}
.newsTabTxt span {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.newsTabTxtMain {
  font-size: 18px;
  color: #333;
  line-height: 18px;
  margin-bottom: 20px;
}
.newsTabTxtSub {
  font-size: 16px;
  color: #666;
  line-height: 16px;
}
</style>
<style>
.sectionOneSlide {
  max-width: 1200px;
  margin: 60px auto 0;
}
.usr-t{
  margin-top: 30px;
  height: 230px;
  overflow: hidden;
   display: -webkit-box !important;
   /* display: -ms-flexbox; */
  -webkit-box-orient: vertical;
  /* -ms-box-orient: vertical;
  -ms-line-clamp: 7; */
  -webkit-line-clamp: 7;
}
.usr-b{
  text-align: center;
}
.usr-b span{
  display: inline-block;
  background: url('../../styles/images/about-Btn.png') no-repeat;
  margin-top: 50px;
  width: 121px;
  height: 36px;
}
.usr-b span:hover{
  cursor: pointer;
}
.sectionOneSlide .el-icon-arrow-left:before,
.sectionOneSlide .el-icon-arrow-right:before {
  content: "" !important;
}
.sectionOneSlide .el-carousel__arrow,
.sectionOneSlide .el-carousel__arrow:hover {
  background-color: transparent;
}
.sectionOneSlide .el-icon-arrow-left {
  display: inline-block;
  width: 21px;
  height: 32px;
  background: url(../../styles/images/arrowLeft.png) no-repeat left top;
  background-size: 100% 100%;
}
.sectionOneSlide .el-icon-arrow-left:hover{
  background: url(../../styles/images/arrowRight.png) no-repeat Right top;
  background-size: 100% 100%;
  transform:rotate(180deg)
}
.sectionOneSlide .el-icon-arrow-right:hover{
  background: url(../../styles/images/arrowRight.png) no-repeat left top;
  background-size: 100% 100%;
  transform:rotate(0deg)
}
.sectionOneSlide .el-icon-arrow-right {
  width: 21px;
  height: 32px;
  background: url(../../styles/images/arrowLeft.png) no-repeat left top;
  background-size: 100% 100%;
  transform:rotate(180deg)
}
.newslist .titleTxt {
  width: 437px;
  height: 87px;
  background: url("../../styles/images/newImages/xwzx.png") no-repeat;
}
.newslist {
  padding: 0 !important;
}
.sectionOneSlide .el-carousel__arrow--left {
  left: 0px;
}
.sectionOneSlide .el-carousel__arrow--right {
  right: 0px;
}
.sectionOneSlide .el-carousel__container {
  height: 200px !important;
}
.industrySlide .el-carousel__button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.industrySlideLeft{
  width: 868px;
  height: 531px;
  margin-right: 11px;
  overflow: hidden;
}
.industrySlideRightList{
  cursor: pointer;
  margin-bottom: 11px;
  overflow: hidden;
}
.industrySlideRightList:nth-child(2){
  margin:0;
}
.industrySlideLeftList{
  cursor: pointer;
  float: left;
  margin:0 11px 11px 0;

}
.industrySlideLeftList img{
  width:100%;
  height: 100%;
}
.industrySlideLeftList:nth-child(2),.industrySlideLeftList:nth-child(4){
  margin-right: 0;
}
.industrySlideLeftList:nth-child(3),.industrySlideLeftList:nth-child(4){
  margin-bottom: 0;
}

.home-logo {
  width: 1200px;
  /* height: 531px; */
  margin: 60px auto 0;
  /* display: flex; */
}
.logo-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  /* padding: 20px; */
  /* background-color: #e6f7ff; */
}
.logo-item {
  display: flex;
  justify-content: center;
  align-items: center;
  /* border: 1px dashed #b3d7ff; */
  /* padding: 10px; */
  box-sizing: border-box;
  }
.logo-img {
 width: 100%;
 height: 100%;
  /* height: 91px; */
  /* object-fit: contain; */
  box-shadow: 0px 4px 18px 0px rgba(137,152,192,0.25);
border-radius: 4px 4px 4px 4px;
}


.system-nav {
  display: flex;
  align-items: center;
  padding: 20px;
  width: 1200px;
  margin: 0 auto;
}

.nav-arrow {
  background: transparent;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  z-index: 2;
  img{
    width: 48px;
    height: 48px;
  }
}

.nav-list {
  display: flex;
  flex: 1;
  overflow-x: hidden; /* 隐藏原生滚动条 */
  scroll-behavior: smooth;
  padding: 10px 0;
}

.nav-item {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  margin: 0 50px;
}

.nav-icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.nav-icon.active {
  /* background-color: #f5a623; */
}

.nav-icon i {
  font-size: 24px;
  color: #666;
}

.nav-icon.active i {
  color: #fff;
}

.nav-label {
  font-size: 14px;
  color: #333;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}
.flexTx {
  display: flex;
}
.flexTxCot {
  /* flex: 1;
  cursor: pointer; */
  flex: 0 0 auto; /* 不自动增长或收缩，保持原始尺寸 */
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.flexTxCot img.flexImg {
  width: 100%;
  height: 100%;
 
}
.pr-12 {
  padding-right: 12px;
}
.mb-12 {
  margin-bottom: 12px;
}

.flexImg {
  width: 100%;
  height: 100%;
}

</style>
